import { render, staticRenderFns } from "./AddSpot.vue?vue&type=template&id=64df85f6&scoped=true"
import script from "./AddSpot.vue?vue&type=script&lang=js"
export * from "./AddSpot.vue?vue&type=script&lang=js"
import style0 from "./AddSpot.vue?vue&type=style&index=0&id=64df85f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df85f6",
  null
  
)

export default component.exports